import Vue from 'vue'
import Vuex from 'vuex'
import isMobile from './module//isMobile'
import storeInfo from './module/storeInfo'

Vue.use(Vuex)

// export default new Vuex.Store({

// })
let store = new Vuex.Store({
  modules: {
    isMobile,
    storeInfo,
  },
  strict: true
})
export default store